import { Stack, Typography } from "@mui/material";
import React from "react";
import { EventGoalSvg } from "@onair/ui/svg/event-goal";

interface Props {
	showIcon?: boolean;
}

const DocHeader = ({ showIcon = true }: Props) => {
	return (
		<Stack direction="row" spacing={2} alignItems="center">
			{showIcon && <EventGoalSvg />}
			<Typography variant="subtitle1" flex={1}>
				Tại sao nên tham gia sự kiện?
			</Typography>
		</Stack>
	);
};

export default DocHeader;
